<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="汽车维修培训"
                  :nav-active="navActive"
                  :menuItems="menuItems"></lx-navigator>

    <el-main style="padding: 0 10px; height: 100%; ">
      <el-row class="lx-right-title">
        <el-col>{{ displayType }}拆装的工作顺序</el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>工作顺序</el-col>
        <el-col :span="4" style="text-align: right">
          <el-button v-if="$can('view', 'tms-root-nav')"
                      type="primary"
                      size="small"
                      @click="handleAddLine">
            添加工作顺序
          </el-button>
        </el-col>
      </el-row>
      <el-row style="height: calc(100% - 110px); overflow-y: auto; background: #fff; padding: 10px;">
        <el-col :span="24">
          <el-table :data="processLineData" size="medium" border class="lx-table" row-class-name="lx-table-row" header-cell-class-name="lx-table-header-cell" cell-class-name="lx-table-cell">
            <el-table-column prop="name"
                              align="center"
                              label="步骤名称">
            </el-table-column>
            <el-table-column prop="resource.name"
                              align="center"
                              label="资源名称">
            </el-table-column>
            <el-table-column align="center"
                              label="资源类型">
              模型
            </el-table-column>
            <el-table-column align="center"
                              label="试题"
                              min-width="300">
              <template slot-scope="scope">
                <el-tag v-for="(ques, index) in scope.row.questions"
                        type="info"
                        style="background-color: #F7F7F7; border-color: #DDDDDD; color: #63666f; margin-right: 10px;"
                        :key="ques.value"
                        closable
                        :disable-transitions="false"
                        @close="handleDeleteQuestion(ques, scope.row)">
                  {{ '第' + (index + 1) + '题' }}
                  <i class="el-icon-edit"
                      @click="handleEditQuestion(ques, scope.row)"></i>
                </el-tag>
                <el-tag style="border-style: dashed; background-color: transparent; color: #63666f;border-color: #dddddd; cursor: pointer; "
                        @click.native="handleAddQuestion(scope.row)">+添加</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="resourceNo"
                              align="center"
                              label="动画序列号">
            </el-table-column>
            <el-table-column prop="processOrder"
                              align="center"
                              label="显示顺序">
            </el-table-column>
            <el-table-column v-if="$can('view', 'tms-root-nav')"
                              align="center"
                              label="操作"
                              min-width="100">
              <template slot-scope="scope">
                <el-button type="text"
                            @click="handleEditLine(scope.$index, scope.row)">编辑</el-button>
                <el-button type="text"
                            @click="handleDeleteLine(scope.$index, scope.row)">删除</el-button>
                <el-button type="text"
                            @click="handleAppendLine(scope.$index, scope.row)">追加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-main>

    <lx-process-editor-box :visible.sync="dialogEditorVisible"
                           :processIdentity="editorIdentify"
                           @edit-result="handleEditResult"
                           :apiIndentity="processId"
                           :processType="processType"
                           :existOrder="existOrder"></lx-process-editor-box>

    <lx-question-editor-box :visible.sync="quesEditorVisible"
                             :processIdentify="processIdentify"
                             :questionIdentify="questionIdentify"
                             :apiIndentity="apiIdentity"
                             @edit-result="handleEditResult">
    </lx-question-editor-box>

  </el-container>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { mapState } from 'vuex'
import Navigator from '@/components/common/Navigator'
import StepBar from '@/components/common/StepBar'
import ProcessEditor from '@/components/teaching/ProcessEditor'
import QuestionEditor from '@/components/teaching/QuestionEditor'

export default {
  props: ['displayType', 'nav-active', 'processType'],

  data () {
    return {
      menuItems: [
        {
          index: '1-1',
          name: '',
          value: '',
          children: [
            { index: '1-1-1', name: '', value: '', route: { name: 'EngineHome' } },
            { index: '1-1-2', name: '', value: '', route: { name: 'EngineDisassemblyTools' } },
            { index: '1-1-3', name: '', value: '', route: { name: 'EngineProcessLine' } }
          ]
        },
        {
          index: '2-1',
          name: '',
          value: '',
          children: [
            { index: '2-1-1', name: '', value: '', route: { name: 'CylinderHome' } },
            { index: '2-1-2', name: '', value: '', route: { name: 'CylinderDisassemblyTools' } },
            { index: '2-1-3', name: '', value: '', route: { name: 'CylinderProcessLine' } }
          ]
        },
        {
          index: '3-1',
          name: '',
          value: '',
          children: [
            { index: '3-1-1', name: '', value: '', route: { name: 'CrankshaftHome' } },
            { index: '3-1-2', name: '', value: '', route: { name: 'CrankshaftDisassemblyTools' } },
            { index: '3-1-3', name: '', value: '', route: { name: 'CrankshaftProcessLine' } }
          ]
        },
        {
          index: '4-1',
          name: '',
          value: '',
          children: [
            { index: '4-1-1', name: '', value: '', route: { name: 'SynchronizeHome' } },
            { index: '4-1-2', name: '', value: '', route: { name: 'SynchronizeDisassemblyTools' } },
            { index: '4-1-3', name: '', value: '', route: { name: 'SynchronizeProcessLine' } }
          ]
        }
      ],
      processLineData: [
        // {
        //   id: '0001',
        //   name: '111'
        // }
      ],
      editorIdentify: {},
      dialogEditorVisible: false,
      quesEditorVisible: false,
      processIdentify: {},
      questionIdentify: {},
      apiIdentity: null,
      processId: null,
      existOrder: [],
      existType: []
    }
  },

  watch: {
    // menuItems: {
    //   handler: function (newVal, oldVal) {
    //     this.$nextTick(function () {
    //       if (newVal[3].children[2].value) {
    //         this.getProcessLine()
    //       }
    //     })
    //   },
    //   deep: true
    // }
  },

  components: { 'lx-navigator': Navigator, 'lx-step-bar': StepBar, 'lx-process-editor-box': ProcessEditor, 'lx-question-editor-box': QuestionEditor },

  computed: {
    ...mapState(['user']),
    title () { return this.processType ? this.processType + '步骤' : '工作顺序' },
    btnText () { return this.processType ? '添加步骤' : '添加工作顺序' },
    process () {
      if (this.processType === '拆解') {
        return 'processes'
      } else if (this.processType === '检测') {
        return 'detection'
      } else if (this.processType === '组装') {
        return 'assemble'
      } else {
        return 'processes'
      }
    }
  },

  mounted () {
    this.getMenu()
  },

  methods: {
    getProcessLine () {
      var temp = _.cloneDeep(this.menuItems)
      switch (this.displayType) {
        /** 解决接口参数错误问题 */
        case '发动机':
          this.apiIdentity = temp[0].value
          this.processId = temp[0].children[2].value
          break
        case '气缸':
          this.apiIdentity = temp[1].value
          this.processId = temp[1].children[2].value
          break
        case '曲轴':
          this.apiIdentity = temp[2].value
          this.processId = temp[2].children[2].value
          break
        case '变速器同步器':
          this.apiIdentity = temp[3].value
          this.processId = temp[3].children[2].value
          break
      }
      if (this.apiIdentity) {
        this.$xhrGet(`/projects/${this.apiIdentity}/items/processes/teach`)
          .then(rs => {
            this.processLineData = rs.data
            if (rs.data.length > 0) {
              this.existOrder = _.uniq(_.map(rs.data, 'processOrder'))
              this.existType = _.uniq(_.map(rs.data, 'resource'))
            } else {
              this.existOrder = []
              this.existType = []
            }
          })
      }
    },
    /** delete question */
    handleDeleteQuestion (ques, row) {
      this.$xhrDelete(`/processes/questions/${ques.questionId}`).then(rs => {
        if (rs.code === 200) {
          this.$message.success('删除试题成功！')
          this.getProcessLine()
        }
      })
    },
    /** edit question */
    handleEditQuestion (ques, row) {
      this.processIdentify = row
      this.questionIdentify = ques
      Vue.set(this.questionIdentify, 'edit', true)
      this.quesEditorVisible = true
    },
    /** add question */
    handleAddQuestion (row) {
      this.processIdentify = row
      this.questionIdentify = {}
      Vue.set(this.questionIdentify, 'edit', false)
      this.quesEditorVisible = true
    },
    /** add process line */
    handleAddLine () {
      let lastResource
      if (!_.isEmpty(this.existType)) {
        lastResource = this.existType[this.existType.length - 1].value
      } else {
        lastResource = null
      }
      this.editorIdentify = {}
      Vue.set(this.editorIdentify, 'lastResource', lastResource)
      this.dialogEditorVisible = true
    },
    /** append process line */
    handleAppendLine (index, row) {
      this.editorIdentify = row
      Vue.set(this.editorIdentify, 'operate', '追加')
      this.dialogEditorVisible = true
    },
    /** edit process line */
    handleEditLine (index, row) {
      this.editorIdentify = row
      Vue.set(this.editorIdentify, 'operate', '编辑')
      this.dialogEditorVisible = true
    },
    /** delete process line */
    handleDeleteLine (index, row) {
      let lineParam = {
        'trainProjectItemId': this.processId,
        'processOrder': row.processOrder
      }
      this.$xhrPatch(`/projects/items/processes/${row.id}`, lineParam)
        .then(rs => {
          if (rs.code === 200) {
            this.getProcessLine()
          }
        })
    },
    handleEditResult () {
      this.getProcessLine()
    },
    getMenu () {
      var temp = _.cloneDeep(this.menuItems)
      this.$xhrGet(`/projects`)
        .then(rs => {
          for (let i = 0, len = rs.data.length; i < len; i++) {
            temp[i].name = rs.data[i].name
            temp[i].value = rs.data[i].value
          }
          for (let j = 0, lenth = temp.length; j < lenth; j++) {
            this.$xhrGet(`/projects/${temp[j].value}`)
              .then(rs => {
                for (var k = 0, len = rs.data.length; k < len; k++) {
                  var tempArr = temp[j].children
                  tempArr[k].name = rs.data[k].name
                  tempArr[k].value = rs.data[k].value
                }
              })
          }
        })
      this.menuItems = temp
      setTimeout(() => {
        this.getProcessLine()
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag--info /deep/ {
  .el-icon-edit {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    vertical-align: middle;
    top: -1px;
    right: -5px;
  }
}
.el-tag--info /deep/ {
  .el-icon-edit:hover {
    background-color: #909399;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teaching/ProcessLine.vue